var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-home"},[_c('div',{staticClass:"v-home__container"},[_c('div',{staticClass:"v-home__intro"},[(_vm.isProduction)?_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('sell.error'))+"\n            ")]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }